import PieChartIcon2 from "../../../assets/Icons/PieChartIcon2.js";
import PersonalInfoIcon from "../../../assets/Icons/PersonalInfoIcon.js";
import DocumentIcon from "../../../assets/Icons/DocumentIcon.js";
import LogoutIcon from "../../../assets/Icons/LogoutIcon.js";
import VerifyIcon from "../../../assets/Icons/VerifyIcon.js";
import { DashboardRoutesLinks, RoutesLink } from "../../../router/RoutesLink.js";
import { Link } from "react-router-dom";
const UserDetailList = () => {
  const profileMenu = [
    {
      icon: <PieChartIcon2 />,
      label: "My Dashboard",
      link: DashboardRoutesLinks?.dashboard,
    },
    {
      icon: <PersonalInfoIcon />,
      label: "My Account",
      link: DashboardRoutesLinks?.myAccount,
    },
    {
      icon: <VerifyIcon />,
      label: "Sign in & Security",
      link: "/",
    },
    {
      icon: <DocumentIcon />,
      label: "Legal Documents",
      link: "/",
    },
    {
      icon: <LogoutIcon />,
      label: "Log Out",
      link: "/",
    },
  ];
  return (<ul
    className="font-Apparat font-[400] text-[16px] leading-[19.2px]
                  tracking-[-2%]"
  >
    {profileMenu?.map((item, ind) => (
      <li
        key={ind}
        className={
          "hover:text-primary flex gap-[12px] my-[16px]"
        }
      >
        <Link
          to={item?.link}
          className="flex gap-[4px]">
          {item?.icon}
          {item?.label}
        </Link>

      </li>
    ))}
  </ul>)
}

export default UserDetailList;